import React from 'react';
import { Card, Input } from 'antd';

const Question = ({ result, question, onChange }) => {
  const { title, type, value } = result;

  const onChangeProxy = e => {
    onChange(Number(e.target.value));
  };

  const prepareValue = Number(value || 0);

  return (
    <Card>
      <p>Title: {title}</p>
      <p>Type: {type}</p>
      <Input type="number" onChange={onChangeProxy} placeholder="1" value={prepareValue} />
    </Card>
  );
};

export default Question;
